
















































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { api } from "@/store/modules/data";

import LineChart from "@/components/charts/LineChart";
import BarChart from "@/components/charts/BarChart";
import PieChart from "@/components/charts/PieChart";

import {
  calculateCombinedMeasuresPerMonthAverageProcessingTimeData,
  calculateFingingsTypesProportionData,
  calculateMeasureTypesProportionData,
  calculateMeasureDueDateProportionData
} from "@/utils/DataTransformations";

import "chartjs-plugin-colorschemes";

@Component({
  components: {
    LineChart,
    BarChart,
    PieChart
  }
})
export default class Audit extends Vue {
  loading = false;

  chartJSOptions = {
    maintainAspectRatio: false,
    plugins: {
      colorschemes: {
        scheme: "brewer.SetOne9"
      }
    }
  };

  pieChartLegendRight = {
    legend: {
      position: "right"
    }
  };
  pieChartLegendTop = {
    legend: {
      position: "top"
    }
  };

  @Action(api.actions.loadData, { namespace: api.namespace })
  loadData!: () => Promise<void>;

  @Getter(api.getters.getRawData, {
    namespace: api.namespace
  })
  rawData!: any;

  get combinedMeasuresPerMonthAverageProcessingTimeData() {
    return calculateCombinedMeasuresPerMonthAverageProcessingTimeData(
      this.rawData
    );
  }

  get findingsPoportionData() {
    const data = calculateFingingsTypesProportionData(this.rawData);
    console.log(data);
    return data;
  }

  get measureTypesPoportionData() {
    return calculateMeasureTypesProportionData(this.rawData);
  }

  get measureDueDatePoportionData() {
    return calculateMeasureDueDateProportionData(this.rawData);
  }

  mounted() {
    this.loadData();
  }
}
